export enum ButtonTheme {
    buttonPrimary = 'theme-button-primary',
    buttonSecondary = 'theme-button-secondary',
    buttonLight = 'theme-button-light',
}
